
export const riskColor = {
    'low': 'green',
    'Risco habitual': 'green',
    'medium': 'yellow',
    'high': 'red',
    'Alto risco': 'red',
    'Alto risco com patologia controlada': 'orange'
}

export const riskLabel = {
    'low': 'Baixo',
    'Risco habitual': 'Habitual',
    'medium': 'Médio',
    'high': 'Alto',
    'Alto risco': 'Alto',
    'Alto risco com patologia controlada': 'Alto com PC'
}